import { ColorsRaw } from '@/ui/theme/colors-raw';

export const listItemHoverStyle = {
  my: 0.5,
  '& .MuiListItemButton-root': {
    borderRadius: '20px',
  },
  '&$selected': {
    borderRadius: '20px',
    '& .MuiListItemButton-root': {
      backgroundColor: ColorsRaw.anthracite.Warm_Anthracite_2,
      borderRadius: '20px',
    },
  },
  '&$selected:hover': {
    borderRadius: '20px',
    '& .MuiListItemButton-root': {
      backgroundColor: ColorsRaw.anthracite.Warm_Anthracite_2,
      borderRadius: '20px',
    },
  },
  '&:hover': {
    borderRadius: '20px',
    '& .MuiListItemButton-root': {
      backgroundColor: ColorsRaw.anthracite.Warm_Anthracite_2,
      borderRadius: '20px',
    },
  },
};
